import React from 'react';
import './UpcomingTraining.css';

const UpcomingTraining = () => {
  const trainings = [
    {
      id: 1,
      title: 'Africa-Continental Project Development & Financing: Green Investment Workshop',
      strategicObjective: 'Prepare finance-ready continental projects aligned with Nigeria Infrastructure Master Plan, PIDA, AfCFTA, AU Climate Strategy and Africa Carbon Market initiatives. Ensure bankability and ESG compliance.',
      venue: 'Afreximbank Africa Trade Centre (AATC), Abuja',
      date: '25–17 August 2026',
      sectors: ['Renewable Energy', 'Transport Corridors', 'Industrial Parks', 'Carbon Markets', 'Security Infrastructure'],
      outcomes: '15–25 Investment-Ready Dossiers'
    }
  ];

  return (
    <div className="training-page">
      <section 
        className="training-hero"
        style={{
        //   backgroundImage: `linear-gradient(135deg, rgba(43, 15, 5, 0.9) 0%, rgba(74, 51, 38, 0.75) 50%, rgba(43, 15, 5, 0.9) 100%), url('/images/aicis-2026-bg.png')`,
          backgroundSize: 'cover',
          backgroundPosition: 'center',
          backgroundAttachment: 'fixed'
        }}
      >
        <div className="training-hero-overlay"></div>
        <div className="training-hero-content">
          <span className="training-badge">AICIS 2026</span>
          <h1>Project Development & Financing</h1>
          <p className="training-subtitle">Green Investment Training Workshop</p>
          <div className="training-hero-stats">
            <div className="stat-item">
              <span className="stat-number">1</span>
              <span className="stat-label">Workshop</span>
            </div>
            <div className="stat-item">
              <span className="stat-number">25</span>
              <span className="stat-label">Investment Dossiers</span>
            </div>
            <div className="stat-item">
              <span className="stat-number">5</span>
              <span className="stat-label">Key Sectors</span>
            </div>
          </div>
        </div>
      </section>

      <section className="training-section">
        <div className="container">
          {trainings.map((training) => (
            <div className="training-detail-card" key={training.id}>
              <div className="training-header">
                <div className="training-icon">📈</div>
                <h2>{training.title}</h2>
              </div>

              <div className="training-grid">
                <div className="training-info-block">
                  <div className="info-icon">🎯</div>
                  <h3>Strategic Objective</h3>
                  <p>{training.strategicObjective}</p>
                </div>

                <div className="training-info-block">
                  <div className="info-icon">📍</div>
                  <h3>Venue</h3>
                  <p>{training.venue}</p>
                </div>

                <div className="training-info-block">
                  <div className="info-icon">📅</div>
                  <h3>Date</h3>
                  <p>{training.date}</p>
                </div>
              </div>

              <div className="training-sectors">
                <h3>🎯 Targeted Sectors</h3>
                <div className="sector-tags">
                  {training.sectors.map((sector, idx) => (
                    <span className="sector-tag" key={idx}>{sector}</span>
                  ))}
                </div>
              </div>

              <div className="training-outcomes">
                <div className="outcome-icon">📊</div>
                <div className="outcome-content">
                  <h3>Expected Outcomes</h3>
                  <p>{training.outcomes}</p>
                </div>
              </div>
            </div>
          ))}
        </div>
      </section>

      <section className="training-cta">
        <div className="container">
          <div className="cta-content">
            <h2>Ready to Participate?</h2>
            <p>Register your interest for the Africa-Continental Project Development & Financing Training.</p>
            <button className="btn-gold" onClick={() => window.location.href = '/partnership-collaboration'}>
              Register Now
            </button>
          </div>
        </div>
      </section>
    </div>
  );
};

export default UpcomingTraining;